<template>
  <DatePicker
    :value="currentValue"
    :format="normalizedFormat"
    :formatter="formatter"
    :lang="language"
    :disabled-date="normalizedDisabledDate"
    :editable="typeable"
    :placeholder="placeholder"
    :inline="inline"
    :default-value="openDate"
    :clearable="clearable"
    :input-class="inputClass"
    v-bind="$attrs"
    @update:value="onUpdate"
  />
</template>

<script>
import DatePicker from 'vue-datepicker-next';

export default {
  name: 'BcfDatepicker',
  components: { DatePicker },
  inheritAttrs: false,
  props: {
    modelValue: { type: [Date, String, Number, Array, null], default: undefined },
    value: { type: [Date, String, Number, Array, null], default: null },
    format: { type: [String, Function], default: 'dd/MM/yyyy' },
    language: { type: [String, Object], default: undefined },
    disabledDates: { type: [Function, Object], default: undefined },
    typeable: { type: Boolean, default: true },
    placeholder: { type: String, default: '' },
    inline: { type: Boolean, default: false },
    openDate: { type: [Date, String, Number], default: undefined },
    clearable: { type: Boolean, default: true },
    inputClass: { type: String, default: 'form-control' },
  },
  emits: ['update:modelValue', 'input', 'selected'],
  computed: {
    currentValue() {
      return this.modelValue === undefined ? this.value : this.modelValue;
    },
    normalizedFormat() {
      if (typeof this.format !== 'string') return 'DD/MM/YYYY';
      return this.format
        .replace(/yyyy/g, 'YYYY')
        .replace(/dd/g, 'DD');
    },
    formatter() {
      if (typeof this.format !== 'function') return undefined;
      return {
        stringify: (date) => this.format(date),
      };
    },
    normalizedDisabledDate() {
      if (typeof this.disabledDates === 'function') {
        return this.disabledDates;
      }

      const disabledDates = this.disabledDates || {};

      return (date) => {
        if (disabledDates.from && date > new Date(disabledDates.from)) {
          return true;
        }
        if (disabledDates.to && date < new Date(disabledDates.to)) {
          return true;
        }
        if (disabledDates.days?.includes(date.getDay())) {
          return true;
        }
        if (disabledDates.daysOfMonth?.includes(date.getDate())) {
          return true;
        }
        return false;
      };
    },
  },
  methods: {
    onUpdate(value) {
      this.$emit('update:modelValue', value);
      this.$emit('input', value);
      this.$emit('selected', value);
    },
  },
};
</script>
